export default __webpack_public_path__ + "static/media/empty-forms.20e25ced.svg";